import { render } from "./Paginas.vue?vue&type=template&id=88ad8782&scoped=true"
import script from "./Paginas.vue?vue&type=script&lang=js"
export * from "./Paginas.vue?vue&type=script&lang=js"

import "./Paginas.vue?vue&type=style&index=0&id=88ad8782&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ad8782"]])

export default __exports__